export default __webpack_public_path__ + "static/media/pears.47a2293d.webp";